/**
 * Leaves the start page for another address, in the same tab: a provider's
 * sign-in, or the applicant flow once the application is found.
 *
 * Pushes a history entry (`href`), never `replace()`, so Back returns to the
 * start page rather than to whatever was open before it (see the OAuth
 * redirect note in CLAUDE.md). Its own module so tests can stand in for it:
 * jsdom does not navigate.
 */
export function leaveFor(url: string): void {
  window.location.href = url;
}
